<div class="container-fluid px-4 py-3">
  <div class="row">
    <div class="col-sm-12">
      <div class="card shadow-sm rounded-4 border-0">
        <div class="card-header bg-white border-bottom d-flex justify-content-between align-items-center">
          <h4 class="fw-bold">{{ pageTitle }}</h4>
        </div>

        <div class="card-body">
          <div class="d-flex flex-wrap justify-content-end mb-3 gap-2">
            <!-- Add Recipe Button -->
<a
  [routerLink]="['/add-recipe']"
  class="btn add-recipe-btn rounded-pill text-white">
  <i class="bi bi-plus-circle me-1"></i> Add Recipe
</a>

            <div class="input-group search-box align-self-start">
              <span class="input-group-text bg-white border-end-0">
                <img src="/assets/img/search.png " alt="Search" style="width: 20px; height: 20px;" />
              </span>
              <input pInputText type="text" class="form-control border-start-0" [(ngModel)]="searchfield"
                (keyup)="searchRecipe($event)" placeholder="Search Recipe" />
            </div>

          </div>

          <div class="table-responsive">
            <p-table [value]="receipes" [paginator]="false" [rows]="10" [showCurrentPageReport]="true"
              [tableStyle]="{ 'min-width': '50rem' }"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              class="table table-hover table-bordered align-middle">
              <ng-template pTemplate="header" let-columns>
                <tr class="table-light">
                  <th>#</th>
                  <th>Image</th>
                  <th class="memberName">Recipe Name</th>
                  <th>Type</th>
                  <th class="actionWidth">Action</th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-i="rowIndex" let-rcp>
                <tr>
                  <td>{{ rowNumber + i + 1 }}</td>
                  <td>
                    <img *ngIf="rcp.recipeImageUpload" 
     [src]="'data:image/jpeg;base64,' + rcp.recipeImageUpload" 
     class="img-thumbnail rounded" 
     style="width: 80px; height: auto;" 
     alt="Recipe Image" />

                  </td>
                  <td>{{ rcp.recipeName }}</td>
                  <td>{{ rcp.recipeType }}</td>
                  <td>
                    <a [routerLink]="['/update-recipe', rcp.recipeId || rcp.id]"
                      class="btn btn-outline-primary btn-sm rounded-pill">
                      View/Edit
                    </a>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage" let-receipes>
                <tr>
                  <td [attr.colspan]="5" class="text-center text-muted py-3">
                    No records found
                  </td>
                </tr>
              </ng-template>
            </p-table>

            <p-paginator [rows]="10" [first]="firstPage" [totalRecords]="totalRecords"
              currentPageReportTemplate="{first} - {last} of {totalRecords}" (onPageChange)="getNextPage($event)">
            </p-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>